import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {gsap, TimelineLite} from "gsap";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";
import {IDjPsychoData} from "../server/IDjPsychoData";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoMiniCollectors extends PIXI.Container implements StageLayer {

    private _fsContainer: PIXI.Container;
    private _sfsContainer: PIXI.Container;
    private _multipliersContainer: PIXI.Container;
    private _indicators: PIXI.Sprite[][] = [];
    private _indicatorsSFS: PIXI.Sprite[][] = [];
    private _fsDisabled: PIXI.Sprite[] = [];
    private _sfsDisabled: PIXI.Sprite[] = [];
    private _fsTexts: PIXI.Sprite[] = [];
    private _sfsTexts: PIXI.Sprite[] = [];
    private _sfsTextsTop: PIXI.Sprite[] = [];
    private _colorMultipliers: PIXI.BitmapText[] = [];
    private _collectorFSText: PIXI.spine.Spine[] = [];
    private _collectorIndicator: PIXI.spine.Spine[] = [];
    private _collectorSFSText: PIXI.spine.Spine[] = [];
    private _collectorSFSIndicator: PIXI.spine.Spine[] = [];
    private _indexesVisitedForIndicators: number[] = [];
    private _collectorBurnsSFS: TimelineSprite[] = [];

    constructor() {
        super();
        this.name = "DjPsychoMiniCollectors";

        this.init();
    }

    public resetIndexes(): void {
        this._indexesVisitedForIndicators = [];
    }

    public switchToSFSEnabled(): void {
        const tl: TimelineLite = new TimelineLite();

        for (let i: number = 0; i < this._sfsTexts.length; i++) {
            tl.add(() => {
                this._sfsTexts[i].alpha = this._sfsTextsTop[i].alpha = 0;
                this._sfsTexts[i].visible = this._sfsTextsTop[i].visible = true;
            }, 0);
            tl.to([this._sfsTexts[i], this._sfsTextsTop[i]], {
                duration: 0.2,
                alpha: 1
            }, 0);
        }

        this.onEnteringBonusGame();
    }

    public switchToSFSDisabled(enterBonus: boolean): void {
        const tl: TimelineLite = new TimelineLite();

        for (let i: number = 0; i < this._sfsTexts.length; i++) {
            this._sfsTexts[i].visible = this._sfsTextsTop[i].visible = false;
        }

        this._sfsDisabled.forEach((val: PIXI.Sprite) => {
            val.alpha = 0;
            val.visible = true;

            tl.to(val, {
                duration: 0.2,
                alpha: 1
            }, 0);
        });

        if (enterBonus) {
            this.onEnteringBonusGame();
        }
    }

    public activateTexts(): TimelineLite {
        const data: IDjPsychoData = DjPsycho.model.data,
            activeColorsForFS: boolean[] = data.activeColorsForFS,
            nextMode: string = data.nextMode,
            tl: TimelineLite = new TimelineLite();

        if ((!activeColorsForFS.includes(false) && !DjPsycho.model.isRestore) || (DjPsycho.model.isRestore && (nextMode === DjPsychoGameMode.FREESPIN || nextMode === DjPsychoGameMode.FREESPIN_AVALANCHE))) {
            this.toggleFSDisabled(false);
            this.switchToSFSDisabled(DjPsycho.model.isRestore);

            return tl;
        }
        if (DjPsycho.model.isRestore && nextMode.indexOf(DjPsychoGameMode.FREESPIN_SUPER) > -1) {
            this.switchToSFSEnabled();

            return tl;
        }

        for (let i: number = 0; i < this._sfsTexts.length; i++) {
            this._sfsTexts[i].visible = this._sfsTextsTop[i].visible = false;
        }

        activeColorsForFS.forEach((value: boolean, idx: number) => {
            const fsText: PIXI.Sprite = this._fsTexts[idx];

            if (value && !fsText.visible) {
                tl.add(() => {
                    fsText.alpha = 0;
                    fsText.visible = true;
                }, 0);
                tl.to(fsText, {
                    duration: 0.2,
                    alpha: 1
                }, 0);
            }
        });

        return tl;
    }

    public toggleFSDisabled(visible: boolean): void {
        this._fsDisabled.forEach((val: PIXI.Sprite) => {
            val.visible = visible;
        });
    }

    public deActivateFSTexts(): void {
        const tl: TimelineLite = new TimelineLite();

        this._fsTexts.forEach((fsText: PIXI.Sprite) => {
            if (fsText.visible) {
                tl.to(fsText, {
                    duration: 0.2,
                    alpha: 0
                }, 0);
                tl.add(() => {
                    fsText.visible = false;
                    fsText.alpha = 1;
                });
            }
        });
    }

    public deActivateSFSTexts(): void {
        const tl: TimelineLite = new TimelineLite();

        this._sfsDisabled.forEach((val: PIXI.Sprite) => {
            val.visible = false;
        });

        for (let i: number = 0; i < this._sfsTexts.length; i++) {
            if (this._sfsTexts[i].visible) {
                tl.to([this._sfsTexts[i], this._sfsTextsTop[i]], {
                    duration: 0.2,
                    alpha: 0
                }, 0);
                tl.add(() => {
                    this._sfsTexts[i].visible = this._sfsTextsTop[i].visible = false;
                    this._sfsTexts[i].alpha = this._sfsTextsTop[i].alpha = 1;
                });
            }
        }
    }

    public activateCollectorIndicatorSpine(idx: number, useSFS: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            collectorIndicator: PIXI.spine.Spine = (useSFS ? this._collectorSFSIndicator[idx] : this._collectorIndicator[idx]);

        tl.add([
            () => {
                collectorIndicator.visible = true;
            },
            DjPsycho.createTimelineForAnimation(collectorIndicator, 0, "Indicator_" + (idx + 1), false)
        ]);

        return tl;
    }

    public activateCollectorTextSpine(idx: number, useSFS: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            animNameHelper: string = (useSFS ? "S" : ""),
            collectorFSText: PIXI.spine.Spine = (useSFS ? this._collectorSFSText[idx] : this._collectorFSText[idx]);

        tl.add([
            () => {
                collectorFSText.visible = true;
            },
            DjPsycho.createTimelineForAnimation(collectorFSText, 0, animNameHelper + "FS_" + (idx + 1), false)
        ]);

        return tl;
    }

    public activateColorIndicators(idx: number, calledFromWin: boolean): TimelineLite {
        const colorMultipliersAfterCollapse: number[] = DjPsycho.model.data.colorMultsAfterCollapse,
            value: number = colorMultipliersAfterCollapse[idx],
            tl: TimelineLite = new TimelineLite();

        if (this._indexesVisitedForIndicators.indexOf(idx) > -1) {
            return tl;
        }

        if (calledFromWin) {
            this._indexesVisitedForIndicators.push(idx);
        }

        if (calledFromWin && DjPsycho.model.gameData.mode.indexOf(DjPsychoGameMode.FREESPIN) > -1) {
            return this.activateColorIndicatorsBonusGame(idx);
        }

        if (value > 1) {
            if (DjPsycho.model.data.mode.indexOf(DjPsychoGameMode.NORMAL) > -1) {
                for (let ctr: number = 0; ctr < Math.min(3, value); ctr++) {
                    const indicator: PIXI.Sprite = this._indicators[idx][ctr];

                    if (!indicator.visible) {
                        if (DjPsycho.model.isRestore) {
                            indicator.visible = true;
                        } else {
                            tl.add(() => {
                                indicator.alpha = 0;
                                indicator.visible = true;

                                // #167
                                if (!DjPsycho.anyBonusBought && ctr > 0) {
                                    DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_FILL);
                                }
                            }, 0);
                            tl.to(indicator, {
                                duration: 0.2,
                                alpha: 1
                            }, 0);
                        }
                    }
                }
            }

            tl.add(this.setColorMultiplier(idx, value));

            if (calledFromWin && DjPsycho.model.gameData.activeColorsForFS[idx] && value === 3) {
                tl.add([
                    () => {
                        // #167
                        DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_FULL3);
                    },
                    this.activateCollectorIndicatorSpine(idx, false)
                ]);
            }
        }

        return tl;
    }

    public deActivateColorIndicators(): void {
        const tl: TimelineLite = new TimelineLite();

        this._indicators.forEach((indicatorArr: PIXI.Sprite[]) => {
            indicatorArr.forEach((indicator: PIXI.Sprite) => {
                if (indicator.visible) {
                    tl.to(indicator, {
                        duration: 0.2,
                        alpha: 0
                    }, 0);
                    tl.add(() => {
                        indicator.visible = false;
                        indicator.alpha = 1;
                    }, 0.2);
                }
            });
        });

        this.turnOffColorMultiplier();
    }

    public onExitingBonusGame(): void {
        const colorMultipliersAfterCollapse: number[] = DjPsycho.model.data.colorMultsAfterCollapse;

        colorMultipliersAfterCollapse.forEach((val: number, idx: number) => {
            if (val > 1) {
                for (let ctr: number = 0; ctr < Math.min(3, val); ctr++) {
                    this._indicators[idx][ctr].visible = true;
                }
            }
        });

        this._indicatorsSFS.forEach((indicators: PIXI.Sprite[]) => {
            indicators.forEach((indicator: PIXI.Sprite) => {
                indicator.visible = false;
            });
        });

        this.turnOffBurns();
    }

    public flyMultiToTotalMultiplier(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            toX: number = 630,
            toY: number = 182;

        this._colorMultipliers.forEach((multiplier: PIXI.BitmapText) => {
            if (+(multiplier.text.split("x")[1]) > 1) {
                const item: PIXI.BitmapText = new PIXI.BitmapText("x1", {
                    fontName: DjPsychoGameAssets.BITMAP_FONT_SYM_MULTIPLIER,
                    fontSize: 40
                });
                item.anchor = new PIXI.Point(0.5, 0.5);
                item.position = multiplier.position;

                tl.add(() => {
                    this.addChild(item);
                }, 0);
                tl.to(item, {
                    duration: 0.5,
                    x: toX,
                    y: toY
                }, 0);
                tl.to(item.scale, {
                    duration: 0.5,
                    x: 0.3,
                    y: 0.3
                }, 0);
                tl.add(() => {
                    if (item.parent) {
                        item.parent.removeChild(item);
                    }
                    item.destroy();
                });
            }
        });

        return tl;
    }

    // #53 -> When multi goes above x10 make it burn/any animation.
    public burnCollectorsInSFS(): void {
        const isSFS: boolean = DjPsycho.model.data.mode.indexOf("FREESPIN_SUPER") > -1,
            colorMultipliersAfterCollapse: number[] = DjPsycho.model.data.colorMultsAfterCollapse;

        if (isSFS) {
            colorMultipliersAfterCollapse.forEach((value: number, idx: number) => {
                if (value > 9) {
                    this._collectorBurnsSFS[idx].show();
                    this._collectorBurnsSFS[idx].playLoop();
                }
            });
        }
    }

    private init(): void {
        const totalColors: number = 5,
            baseY: number = 286,
            baseXForIndicators: number = 584;
        let colorMultiplier: PIXI.BitmapText;

        this._fsContainer = new PIXI.Container();
        this._sfsContainer = new PIXI.Container();
        this._multipliersContainer = new PIXI.Container();

        this.createLayoutForFS(totalColors, baseY);
        this.createLayoutForSFS(totalColors, baseY);

        for (let ctr: number = 0; ctr < totalColors; ctr++) {
            colorMultiplier = new PIXI.BitmapText("", {
                fontName: DjPsychoGameAssets.BITMAP_FONT_SYM_MULTIPLIER,
                fontSize: 22
            });
            colorMultiplier.visible = false;
            colorMultiplier.position.set(baseXForIndicators + 32, (ctr * 47) + baseY);
            colorMultiplier.anchor = new PIXI.Point(0.5, 0.5);
            this._colorMultipliers.push(colorMultiplier);
            this._multipliersContainer.addChild(colorMultiplier);
        }

        this.addChild(this._fsContainer, this._sfsContainer, this._multipliersContainer);
    }

    private createLayoutForFS(totalColors: number, baseY: number): void {
        const assetName: string = "Collector/In_",
            eachColorIndicator: number = 3,
            baseXForIndicators: number = 584;
        let fsDisabled: PIXI.Sprite,
            fsText: PIXI.Sprite,
            collectorFSText: PIXI.spine.Spine,
            colorIndicator: PIXI.Sprite,
            collectorIndicator: PIXI.spine.Spine;

        for (let ctr: number = 0; ctr < totalColors; ctr++) {
            this._indicators.push([]);
            for (let i: number = 0; i < eachColorIndicator; i++) {
                colorIndicator = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(assetName + (ctr + 1))[0]);
                colorIndicator.visible = false;
                colorIndicator.anchor.set(0.5);
                colorIndicator.position.set((i * 32) + baseXForIndicators, (ctr * 47) + baseY);
                this._indicators[ctr].push(colorIndicator);
                this._fsContainer.addChild(colorIndicator);
            }

            fsDisabled = new PIXI.Sprite(DjPsycho.assetLoader.getTextures("Collector/FS_Dis")[0]);
            fsDisabled.anchor.set(0.5);
            fsDisabled.position.set(690, (ctr * 47) + baseY);
            this._fsDisabled.push(fsDisabled);
            this._fsContainer.addChild(fsDisabled);

            fsText = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(assetName + (ctr + 1) + "_FS")[0]);
            fsText.visible = false;
            fsText.anchor.set(0.5);
            fsText.position = fsDisabled.position;
            fsText.blendMode = PIXI.BLEND_MODES.ADD;
            this._fsTexts.push(fsText);
            this._fsContainer.addChild(fsText);
        }

        for (let ctr: number = 0; ctr < totalColors; ctr++) {
            collectorIndicator = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("fsIndicatorSpine"));
            collectorIndicator.visible = false;
            collectorIndicator.position.set(615, (ctr * 47) + baseY);
            this._collectorIndicator.push(collectorIndicator);
            this._fsContainer.addChild(collectorIndicator);

            collectorFSText = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("fsTextSpine"));
            collectorFSText.visible = false;
            collectorFSText.position.set(690, (ctr * 47) + baseY);
            this._collectorFSText.push(collectorFSText);
            this._fsContainer.addChild(collectorFSText);
        }
    }

    private createLayoutForSFS(totalColors: number, baseY: number): void {
        const assetNameSFS: string = "Collector_SFS/In_",
            eachColorIndicator: number = 5,
            baseXForIndicators: number = 576;
        let sfsDisabled: PIXI.Sprite,
            sfsText: PIXI.Sprite,
            sfsTextTop: PIXI.Sprite,
            collectorSFSText: PIXI.spine.Spine,
            colorIndicator: PIXI.Sprite,
            collectorSFSIndicator: PIXI.spine.Spine,
            collectorBurn: TimelineSprite;

        for (let ctr: number = 0; ctr < totalColors; ctr++) {
            this._indicatorsSFS.push([]);
            for (let i: number = 0; i < eachColorIndicator; i++) {
                colorIndicator = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(assetNameSFS + (ctr + 1))[0]);
                colorIndicator.visible = false;
                colorIndicator.anchor.set(0.5);
                colorIndicator.position.set((i * 20) + baseXForIndicators, (ctr * 47) + baseY);
                this._indicatorsSFS[ctr].push(colorIndicator);
                this._sfsContainer.addChild(colorIndicator);
            }

            sfsDisabled = new PIXI.Sprite(DjPsycho.assetLoader.getTextures("Collector/SFS_Dis")[0]);
            sfsDisabled.visible = false;
            sfsDisabled.anchor.set(0.5);
            sfsDisabled.position.set(690, (ctr * 47) + baseY);
            this._sfsDisabled.push(sfsDisabled);
            this._sfsContainer.addChild(sfsDisabled);

            sfsText = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(assetNameSFS + (ctr + 1) + "_SFS")[0]);
            sfsText.visible = false;
            sfsText.anchor.set(0.5);
            sfsText.position = sfsDisabled.position;
            sfsText.blendMode = PIXI.BLEND_MODES.ADD;
            this._sfsTexts.push(sfsText);
            this._sfsContainer.addChild(sfsText);

            sfsTextTop = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(assetNameSFS + (ctr + 1) + "_SFS_Top")[0]);
            sfsTextTop.visible = false;
            sfsTextTop.anchor.set(0.5);
            sfsTextTop.position = sfsDisabled.position;
            this._sfsTextsTop.push(sfsTextTop);
            this._sfsContainer.addChild(sfsTextTop);
        }

        for (let ctr: number = 0; ctr < totalColors; ctr++) {
            collectorBurn = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_Collector_Burn/FX_Collector_Burn_"));
            collectorBurn.hide();
            collectorBurn.anchor.set(0.5);
            collectorBurn.blendMode = PIXI.BLEND_MODES.ADD;
            collectorBurn.position.set(615, (ctr * 47) + 225);
            this._collectorBurnsSFS.push(collectorBurn);
            this._sfsContainer.addChild(collectorBurn);

            collectorSFSIndicator = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("sfsIndicatorSpine"));
            collectorSFSIndicator.visible = false;
            collectorSFSIndicator.position.set(615, (ctr * 47) + baseY);
            this._collectorSFSIndicator.push(collectorSFSIndicator);
            this._sfsContainer.addChild(collectorSFSIndicator);

            collectorSFSText = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("sfsTextSpine"));
            collectorSFSText.visible = false;
            collectorSFSText.position.set(690, (ctr * 47) + baseY);
            this._collectorSFSText.push(collectorSFSText);
            this._sfsContainer.addChild(collectorSFSText);
        }
    }

    private onEnteringBonusGame(): void {
        const colorMultipliersAfterCollapse: number[] = DjPsycho.model.data.colorMultsAfterCollapse;

        colorMultipliersAfterCollapse.forEach((val: number, idx: number) => {
            if (val > 1) {
                for (let ctr: number = 0; ctr < Math.min(5, val); ctr++) {
                    this._indicatorsSFS[idx][ctr].visible = true;
                }

                if (val > 4) {
                    this._sfsDisabled[idx].visible = false;

                    this._sfsTexts[idx].visible = this._sfsTextsTop[idx].visible = true;
                }
            }
        });

        this._indicators.forEach((indicators: PIXI.Sprite[]) => {
            indicators.forEach((indicator: PIXI.Sprite) => {
                indicator.visible = false;
            });
        });

        this.toggleFSDisabled(false);
    }

    private activateColorIndicatorsBonusGame(idx: number): TimelineLite {
        const colorMultipliersAfterCollapse: number[] = DjPsycho.model.data.colorMultsAfterCollapse,
            value: number = colorMultipliersAfterCollapse[idx],
            tl: TimelineLite = new TimelineLite();

        if (value > 1) {
            for (let ctr: number = 0; ctr < Math.min(5, value); ctr++) {
                const indicator: PIXI.Sprite = this._indicatorsSFS[idx][ctr];

                if (!indicator.visible) {
                    tl.add(() => {
                        indicator.alpha = 0;
                        indicator.visible = true;

                        // #167
                        if (ctr > 0) {
                            DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_FILL);
                        }
                    }, 0);
                    tl.to(indicator, {
                        duration: 0.2,
                        alpha: 1
                    }, 0);
                }
            }

            tl.add(this.setColorMultiplier(idx, value));

            if (value === 3) {
                tl.add(DjPsycho.additionalFS.awardExtraFS((idx + 1)));
            } else if (value === 5) {
                tl.add([
                    () => {
                        // #167
                        DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_FULL5);
                    },
                    this.activateCollectorIndicatorSpine(idx, true)
                ]);
                tl.add(() => {
                    this._sfsDisabled[idx].visible = false;

                    this._sfsTexts[idx].visible = this._sfsTextsTop[idx].visible = true;
                });
            }
        }

        return tl;
    }

    public setColorMultiplier(idx: number, value: number): TimelineLite {
        const item: PIXI.BitmapText = this._colorMultipliers[idx],
            tl: TimelineLite = new TimelineLite();

        if (item.visible && (parseInt(item.text.split("x")[1]) !== value)) {
            gsap.killTweensOf(item);

            // #167
            tl.add(() => {
                // #167
                DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_MULTI_UP);
            });
            tl.to(item.scale, {
                x: 1.8,
                y: 1.8,
                duration: (5 / 30)
            });
            tl.add(() => {
                this.setValueOnColorIndicator(item, value);
            });
            tl.to(item.scale, {
                x: 1,
                y: 1,
                duration: (5 / 30)
            });
        } else {
            tl.add(() => {
                this.setValueOnColorIndicator(item, value);
                item.visible = true;

                if (!DjPsycho.model.isRestore && !DjPsycho.anyBonusBought) {
                    // #167
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_ADD_MULTI);
                }
            });
        }

        return tl;
    }

    private turnOffColorMultiplier(): void {
        this._colorMultipliers.forEach((item: PIXI.BitmapText) => {
            if (item.visible) {
                item.visible = false;
                item.text = "";
            }
        });

        this.turnOffBurns();
    }

    private setValueOnColorIndicator(item: PIXI.BitmapText, value: number): void {
        item.fontSize = 22;
        item.text = "x" + value;
        while (item.textWidth > 90) {
            item.fontSize--;
        }
    }

    private turnOffBurns(): void {
        this._collectorBurnsSFS.forEach((item: TimelineSprite) => {
            if (item.visible) {
                item.hide();
            }
        });
    }
}